import React, { useState } from "react";
import styled from "styled-components";
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import Eye from '../../../assets/eye.svg';
import EyeOpen from '../../../assets/eyeOpen.svg';

interface FormInputProps extends FieldProps<string, FieldRenderProps<string>> {
  label?: string;
  placeholder?: string;
  tooltip?: React.ReactNode;
  info?: React.ReactNode;
  error?: React.ReactNode;
  type?: string;
}

export const EmailInput: React.FC<FormInputProps> = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = props.type === 'password';

  return (
    <Field
      type={isPassword ? (showPassword ? 'text' : 'password') : props.type}
      render={(inputProps) => (
        <Container>
          <InputWrapper>
            <AuthInput
              placeholder={props.placeholder}
              error={!!props.error}
              {...inputProps.input}
              type={isPassword ? (showPassword ? 'text' : 'password') : props.type}
            />
            {isPassword && (
            
              <EyeIcon
               
                onClick={() => setShowPassword((prev) => !prev)}
              >   {!showPassword ? <EyeOpen/> : <Eye/>}</EyeIcon>
            )}
          </InputWrapper>
          {!!props.info && <Info>{props.info}</Info>}
          {!!props.error && <Error>{props.error}</Error>}
        </Container>
      )}
      {...props}
    />
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const AuthInput = styled.input<{ error?: boolean }>`
  background-color: #1a1a1a !important;
  border: 1px solid ${props => props.error ? '#FF5151' : '#333'};
  border-radius: 12px;
  padding: 14px 45px 14px 16px; /* տեղ թողանք աչքի համար */
  font-size: 16px;
  font-weight: 300;
  color: #fff;
  width: 100%;
  height: 50px;

  &:focus {
    outline: none;
    border-color: #fff;
  }

  &::placeholder {
    color: #888;
  }
`;

const EyeIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const Info = styled.span`
  font-size: 12px;
  color: #888;
`;

const Error = styled.span`
  font-size: 14px;
  line-height: 19px;
  color: #FF5151;
`;
